var kind = require("enyo/kind");

require("./BottomGradient.less");

module.exports = kind(/** @lends  app.ui.header.BottomGradient.prototype */ {

    /**
     * @private
     */
    name: "app.ui.header.BottomGradient",

    /**
     * @private
     */
    classes: "app-ui-header-bottom-gradient"

});
